import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartaoBi } from 'app/resources/bi/cartao.bi';
import { Cartao } from 'app/resources/classes/cartao';
import { Rotas } from 'app/resources/classes/rotas';
import { HttpService } from 'app/resources/services';
import { AlertService } from 'app/resources/services/alert.service';
import { VoucherService } from 'app/resources/services/voucher.service';

@Component({
  selector: 'app-voucher-confirmar',
  templateUrl: './voucher-confirmar.component.html'
})
export class VoucherConfirmarComponent implements OnInit {

  constructor(private httpService: HttpService, private router: Router, public voucherService: VoucherService, private alertService: AlertService) { }

  ngOnInit() {
    if (this.voucherService.voucherPrincipal === undefined) {
      this.voucherService.voucherPrincipal = new Cartao();
      this.atualizaNumeroDoVoucherPrincipal();
    }
  }

  public irParaTelaResgatarVouchers(): void {
    this.router.navigate([Rotas.VOUCHER_RESGATAR]);
  }

  private atualizaNumeroDoVoucherPrincipal(): void {
    new CartaoBi.Rest(this.httpService).getNumero()
      .subscribe(
        success => {
          this.voucherService.voucherPrincipal.setNumero(success.json());
        },
        error => {
          this.alertService.errorAlert(error._body);
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/voucher/voucher-confirmar/voucher-confirmar.component.ts